import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

const useLanguage = () => {
  const { i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const language = searchParams.get('language');

    if (language) {
      i18n.changeLanguage(language);
    }
  }, [location.search, i18n]);
};

export default useLanguage;
